<template>
  <div>
    <b-container fluid class="content">
      <b-card no-body>
        <b-card-body>
          <b-form>
            <b-row>
              <b-col>
                <base-input :label="$t('From Date')">
                  <b-row>
                    <b-col>
                      <flat-pickr
                        :config="configs"
                        class="form-control"
                        :placeholder="$t('From Date') + '...'"
                        v-model="from_date"
                      >
                      </flat-pickr>
                    </b-col>
                  </b-row>
                </base-input>
              </b-col>
              <b-col>
                <base-input :label="$t('To Date')">
                  <b-row>
                    <b-col>
                      <flat-pickr
                        :config="configs"
                        class="form-control"
                        :placeholder="$t('To Date') + '...'"
                        v-model="to_date"
                      >
                      </flat-pickr>
                    </b-col>
                  </b-row>
                </base-input>
              </b-col>
              <b-col v-if="storelist && (storelist.length > 0)">
                <base-input :label="$t('Store')">
                  <select class="form-control" v-model="location_ID">
                    <option></option>
                    <option v-for="(loc, idx) in storelist" :key="idx" :value="loc.LocationID" >
                      {{ loc.LocationName }}
                    </option>
                  </select>
                </base-input>
              </b-col>
              <b-col v-if="modifier_groups && (modifier_groups.length > 0)">
                <base-input :label="$t('Modifier Group')">
                  <select class="form-control" v-model="PKModifierGroupIDn">
                    <option value="0"></option>
                    <option v-for="(loc, idx) in modifier_groups" :key="idx" :value="loc.IDn" >
                      {{ getName(loc) }}
                    </option>
                  </select>
                </base-input>
              </b-col>
              <b-col>
                <b-row class="mt-4">
                  <b-col>
                    <button class="btn btn-primary m-2" style="padding: 0.4rem 1rem;" @click.prevent="form_search">
                      {{ $t("Search") }}
                    </button>
                  </b-col>
                  <b-col class="ml-4">
                    <xlsx-workbook>
                      <xlsx-sheet
                        :collection="sheet.data"
                        v-for="sheet in sheets"
                        :key="sheet.name"
                        :sheet-name="sheet.name"
                      />
                      <xlsx-download filename="ModifierReport.xlsx">
                        <button class="btn btn-primary m-2" style="padding: 0.4rem 1rem;">XLSX</button>
                      </xlsx-download>
                    </xlsx-workbook>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card-body>
      </b-card>
    </b-container>
    <b-container fluid>
      <b-card>
        <b-card-body :style="{overflowX: 'auto' }">
          <div v-if="list_data && list_data.records && (list_data.records.length > 0)">
            <b-row>
              <b-col cols="9">
                <div class="name_column">
                  {{ $t("Modifier Report") }}
                </div>
              </b-col>
              <b-col cols="3" class="text-right" v-if="list_data.no_store != 1">
                <b-form-checkbox
                  class="form-checkbox"
                  v-model="show_store"
                  :value="true"
                  :unchecked-value="false"
                  switch
                  >
                  {{ $t("Show Store") }}
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row v-if="show_store && (list_data.no_store != 1)">
              <b-col class="list_name pt-2">
                <b-row>
                  <b-col cols="2" class="list_name pt-2">
                    {{ $t("Squence") }}
                  </b-col>
                  <b-col class="list_name pt-2">
                    {{ $t("Name") }}
                  </b-col>
                  <b-col class="list_name pt-2">
                    {{ $t("Group") }}
                  </b-col>
                  <b-col class="list_name pt-2 text-right" v-for="(store, key) in list_data.stores" :key="key">
                    {{ store.LocationName }}
                  </b-col>
                  <b-col cols="2" class="list_name pt-2 text-right">
                    {{ $t("Quantity") }}
                  </b-col>
                </b-row>
                <b-row v-for="(data, idx) in list_data.records" :key="idx">
                  <b-col cols="2" class="list_count">
                    {{ idx+1 }}
                  </b-col>
                  <b-col class="list_count" v-if="$i18n.locale == 'en'">
                    {{ data.Name1 }}
                  </b-col>
                  <b-col class="list_count" v-else>
                    {{ data.Name2 }}
                  </b-col>
                  <b-col class="list_count" v-if="$i18n.locale == 'en'">
                    {{ data.GroupName1 }}
                  </b-col>
                  <b-col class="list_count" v-else>
                    {{ data.GroupName2 }}
                  </b-col>
                  <b-col class="list_count text-right" v-for="(store, key) in list_data.stores" :key="key">
                    {{ parseInt(data[store.LocationID]) || 0 }}
                  </b-col>
                  <b-col cols="2" class="list_count text-right">
                    {{ parseInt(data.Count) }}
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row v-else>
              <b-col class="list_name pt-2">
                <b-row>
                  <b-col cols="2" class="list_name pt-2">
                    {{ $t("Squence") }}
                  </b-col>
                  <b-col class="list_name pt-2">
                    {{ $t("Name") }}
                  </b-col>
                  <b-col class="list_name pt-2">
                    {{ $t("Group") }}
                  </b-col>
                  <b-col cols="2" class="list_name text-right">
                    {{ $t("Quantity") }}
                  </b-col>
                </b-row>
                <b-row v-for="(data, idx) in list_data.records" :key="idx">
                  <b-col cols="2" class="list_count">
                    {{ idx+1 }}
                  </b-col>
                  <b-col class="list_count" v-if="$i18n.locale == 'en'">
                    {{ data.Name1 }}
                  </b-col>
                  <b-col class="list_count" v-else>
                    {{ data.Name2 }}
                  </b-col>
                  <b-col class="list_count" v-if="$i18n.locale == 'en'">
                    {{ data.GroupName1 }}
                  </b-col>
                  <b-col class="list_count" v-else>
                    {{ data.GroupName2 }}
                  </b-col>
                  <b-col cols="2" class="list_count text-right">
                    {{ parseInt(data.Count) }}
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <div v-else>
            {{ $t('No Records') }}
          </div>
        </b-card-body>
      </b-card>
    </b-container>
    <vue-element-loading
      :active="showLoading"
      spinner="bar-fade-scale"
      color="#FF6700"
      duration="2.0"
      background-color="rgba(255, 255, 255, .5)"
      size="100"
    />

  </div>
</template>
<script>
import {
  Button
} from "element-ui";
import VueElementLoading from "vue-element-loading";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { getStore, setStore } from "../../util/helper";
import { XlsxWorkbook, XlsxSheet, XlsxDownload } from "vue-xlsx";


const axios = require("axios");

export default {
  components: {
    [Button.name]: Button,
    [flatPicker.name]: flatPicker,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
    VueElementLoading,
  },
  data() {
    return {
      showLoading: false,
      from_date: null,
      to_date: null,
      location_ID: null,
      storelist: null,
      PKModifierGroupIDn: 0,
      show_store: false,
      token: "",
      user_id: 0,
      user_name: null,
      only_self: null,
      report_width: null,
      report_from_date: null,
      report_to_date: null,
      report_special_mark: null,
      report_generate_time: null,
      report_last_updated_time: null,
      list_data: null,
      modifier_groups: null,
      sheets: [
        { name: "Sheet1", data: [[1, 2, 2], [1, 2, 2, 2], [], [1, 2, 2, 2]] },
      ],
      configs: {
        allowInput: false,
        enableTime: false,
        noCalendar: false,
        dateFormat: "Y-m-d",
        maxDate: "today",
        time_24hr: true,
      },
      markStyleObject: {
        textAlign: 'left',
        fontWeight: 'bold',
        fontSize: '20px',
      },
      headerStyleObject: {
        textAlign: 'right',
        fontWeight: 'bold',
        fontSize: '18px',
      },
      titleStyleObject: {
        textAlign: 'left',
        textDecoration: 'underline',
        fontWeight: 'bold',
        fontSize: '22px',
      },
      nameStyleObject: {
        textAlign: 'left',
        fontWeight: 'bold',
      },
    };
  },
  watch: {
  },
  computed: {
  },
  methods: {
    remove_dash(myString) {
      return myString.replace(/-/g, "");
    },
    getName(obj) {
      if(this.$i18n.locale == "en") {
        return obj.Name1;
      } else {
        return obj.Name2;
      }
    },
    getModGrpName(idn) {
      for(var i=0; i<this.modifier_groups.length; i++) {
        if(this.modifier_groups[i].IDn == idn){
          return this.modifier_groups[i].Name1 + ' (' + this.modifier_groups[i].Name2 + ')';
        }
      }
      return 'Not found';
    },
    fillup_sheet() {
      // Init 2 dimensional array
      var dataarr = [];
      // console.log("fillup_sheet A",this.list_data);
      if (!this.list_data.records || !Array.isArray(this.list_data.records) || (this.list_data.records.length <= 0)) {
        return;
      }
      if (this.list_data.no_store != 1) {
        if (!this.list_data.stores) {
          return;
        }
      }
      try {
        var x = 1, y = 0;
        dataarr[0] = [];
        dataarr[0][y++] = this.$t("Squence");
        dataarr[0][y++] = this.$t("Name");
        dataarr[0][y++] = this.$t("Group");
        if (this.list_data.no_store != 1) {
          for (const key in this.list_data.stores) {
            dataarr[0][y++] = this.list_data.stores[key].LocationName;
          }
        }
        dataarr[0][y++] = this.$t("Quantity");
        for (var j = 0; j < this.list_data.records.length; j++) {
          var list = this.list_data.records[j];
          y = 0;
          dataarr[x] = [];
          dataarr[x][y++] = x;
          dataarr[x][y++] = (this.$i18n.locale == "en") ? list["Name1"] : list["Name2"];
          dataarr[x][y++] = (this.$i18n.locale == "en") ? list["GroupName1"] : list["GroupName2"];
          if (this.list_data.no_store != 1) {
            for (const key in this.list_data.stores) {
              dataarr[x][y++] = parseInt(list[this.list_data.stores[key].LocationID]) || 0;
            }
          }
          dataarr[x][y++] = parseInt(list.Count);
          x++;
        }
      } catch (err) {
        console.log("fillup_sheet err",err);
      }
      // console.log("fillup_sheet B",dataarr);
      var sheetname = "ModifierReport";
      this.sheets = [{ name: sheetname, data: dataarr }];
    },
    async form_search() {
      this.get_list_data();
    },
    async get_list_data() {
      this.showLoading = true;
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("FromDate", this.from_date);
      bodyFormData.append("ToDate", this.to_date);
      if (this.location_ID != null) {
        bodyFormData.append("LocationID", this.location_ID);
      }
      if (this.PKModifierGroupIDn != 0) {
        bodyFormData.append("PKModifierGroupIDn", this.PKModifierGroupIDn);
      }

      var that = this;
      axios({
        method: "post",
        url: "/Api/ModifierReport",
        data: bodyFormData,
      })
        .then(function (response) {
          that.showLoading = false;
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              that.onlyself = rt.data.onlyself;
              that.storelist = rt.data.storelist;
              that.list_data = rt.data.list_data;
              that.modifier_groups = rt.data.modifier_groups;
              that.user_name = rt.data.username;
              if (that.list_data) {
                that.fillup_sheet();
              }
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              // that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          } else {
            that.$router.push("/login");
          }
        })
        .catch(function (error) {
          that.showLoading = false;
          // console.log(error);
          that.$router.push("/login");
        });
    },
    get_yesterday() {
      var today = new Date();
      // today.setDate(today.getDate() - 1); // change to today
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();

      return yyyy + "-" + mm + "-" + dd;
    },
    async init_data() {
      this.from_date = this.get_yesterday();
      this.to_date = this.get_yesterday();
      this.configs.maxDate = this.to_date;
      this.token = getStore("token");
      this.user_id = getStore("user_id");

      this.get_list_data();
    },

  },
  mounted() {
    this.init_data();
    this.windowHeight = window.innerHeight;
  },
  unmounted(){
  },
};
</script>
<style lang="scss" scoped>
.content {
  padding-top: 40px;
}
/* parent row container */
.result_row {
  display: flex;
  flex-direction: row;
  width: max-content;   /* fit all children width */
  min-width: 100%;      /* at least full container width */
}

/* fixed width columns */
.name_column,
.data_column {
  width: 200px;
  min-width: 200px;
  max-width: 200px;

  border-bottom: 1px solid #ccc;
  box-sizing: border-box;
}

/* common row style */
.list_name,
.list_count {
  width: 100%;
  box-sizing: border-box;
  text-align: left;
}
.list_name {
  background-color: #f8f8f8;
  font-weight: bold;
}
.list_count {
  background-color: #fff;
  font-weight: normal;
}
</style>
